export const WEEKLY = {
  value: "WEEKLY",
  key: "clients.client.premiumSimulator.payrollFrequencyTypes.WEEKLY",
};
export const BIWEEKLY = {
  value: "BIWEEKLY",
  key: "clients.client.premiumSimulator.payrollFrequencyTypes.BIWEEKLY",
};
export const SEMIMONTHLY = {
  value: "SEMIMONTHLY",
  key: "clients.client.premiumSimulator.payrollFrequencyTypes.SEMIMONTHLY",
};
export const MONTHLY = {
  value: "MONTHLY",
  key: "clients.client.premiumSimulator.payrollFrequencyTypes.MONTHLY",
};
export const ANNUAL = {
  value: "ANNUAL",
  key: "clients.client.premiumSimulator.payrollFrequencyTypes.ANNUAL",
};

export default [WEEKLY, BIWEEKLY, SEMIMONTHLY, MONTHLY, ANNUAL];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/payrollFrequencyTypes.js